export const handleResizeObserverError = () => {
  const resizeObserverError = new Event("error");
  resizeObserverError.message = "ResizeObserver loop completed with undelivered notifications.";
  window.addEventListener("error", (e) => {
    if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
      e.stopImmediatePropagation();
    }
  });
};
